/** 总窗口 5,4s，与其余三个游戏一致（PRODUCT_NOTES §0.1）。 */
export const REVEAL_WINDOW_MS = 5400;

/** 最后一位落定后的定格时间。 */
const HOLD_MS = 600;

/**
 * 从右往左依次落定。开奖顺序与奖级规则同构 —— 这是这个玩法紧张感的来源：
 * 每落定一位，还在场的人就少一个数量级（9% → 0,9% → 0,09% → 0,01%）。
 *
 * 时序按位数派生而不是写死 4：位数是随规模上调的旋钮（master §3）。
 */
export function revealSteps(digits: number): { index: number; atMs: number }[] {
  const span = REVEAL_WINDOW_MS - HOLD_MS;
  const step = span / digits;
  return Array.from({ length: digits }, (_, k) => ({
    index: digits - 1 - k,
    atMs: Math.round(step * (k + 1)),
  }));
}

export function digitStateAt(
  elapsedMs: number,
  index: number,
  digits: number,
): 'pending' | 'settled' {
  const step = revealSteps(digits).find((s) => s.index === index);
  if (!step) return 'pending';
  return elapsedMs >= step.atMs ? 'settled' : 'pending';
}

export type RevealCandidateBet = {
  id: number;
  round: number;
  status: string;
  result: string | null;
};

/**
 * Return the oldest round that changed from pending on this mounted page to a
 * concrete win/loss and already carries its authoritative backend result.
 * Historical settled bets present on first load are deliberately not replayed.
 */
export function nextRevealRound(
  bets: RevealCandidateBet[],
  wasPending: ReadonlySet<number>,
  revealed: ReadonlySet<number>,
): number | null {
  const candidate = bets
    .filter((bet) =>
      wasPending.has(bet.id)
      && !revealed.has(bet.id)
      && (bet.status === 'won' || bet.status === 'lost')
      && !!bet.result)
    .sort((a, b) => a.round - b.round || a.id - b.id)[0];
  return candidate?.round ?? null;
}
